module.exports = __webpack_public_path__ + "media/images/front/top/belsomra-7c088b7bdeba84f34d840dd98d680891.png";